<template>
  <div v-if="initialized">
    <div class="vg-content">
      <div class="header text" style="margin-top: 30px;">支付总金额</div>
      <div class="header text">¥
        <div class="price">{{ orderAmount }}</div>
      </div>
      <van-radio-group v-model="checked">
        <vg-card style="margin-top: 30px;" v-if="canWeChat">
          <div class="item" @click="checked = '1'">
            <van-image width="60" height="60" :src="srcWeChat"/>
            <div class="text grow" style="margin-left: 15px;">微信支付</div>
            <van-radio name="1" icon-size="20px"/>
          </div>
        </vg-card>
        <vg-card style="margin-top: 15px;" v-if="canAlipay">
          <div class="item" @click="checked = '2'">
            <van-image width="60" height="60" :src="srcAlipay"/>
            <div class="text grow" style="margin-left: 15px;">支付宝</div>
            <van-radio name="2" icon-size="20px"/>
          </div>
        </vg-card>
      </van-radio-group>
      <div class="hint" v-if="canWeChat || canAlipay">支付说明：请勿重复支付，重复支付发生退款手续费不退回。</div>
      <van-image class="image" v-if="!canWeChat && !canAlipay" width="60" height="60" :src="srcInformation"/>
      <div class="error" v-if="!canWeChat && !canAlipay">{{ hint }}</div>

      <div ref="alipayFormWrapper" v-html="alipayForm"/>
    </div>
    <vg-button-group>
      <vg-button type="primary" @click="onSubmit">立即支付</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import {Image as VanImage, Radio, RadioGroup} from "vant";
import VgCard from "@/components/Commons/VgCard";
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import srcWeChat from "@/assets/scanverify/wechat.png";
import srcAlipay from "@/assets/scanverify/alipay.png";
import {client} from "@/libraries/http";
import srcInformation from "@/assets/scanverify/information.svg";

const isWx = () => /micromessenger/i.test(navigator.userAgent);
const isAlipay = () => /alipayclient/i.test(navigator.userAgent);

export default {
  name: "ChargePay",
  components: {
    VanImage, "van-radio": Radio, "van-radio-group": RadioGroup, VgCard, VgButton, VgButtonGroup,
  },
  data() {
    return {
      srcWeChat: srcWeChat,
      srcAlipay: srcAlipay,
      srcInformation: srcInformation,
      checked: "1",
      orderNo: "",
      orderAmount: "",
      alipayForm: null,
      wx: isWx(),
      isAlipay: isAlipay(),
      openId: "",
      channel: null,
      hint: "",
      initialized: false,
      paymentType: null,
    }
  },
  created() {
    console.log(this.$route);
    this.orderNo = this.$route.query.orderNo;
    this.orderAmount = this.$route.query.orderAmount;
    this.channel = this.$route.query.channel;
    if (this.channel == null) {
      this.getPaymentChannel()
          .then(() => this.initialized = true)
    } else if (this.channel == 2) {
      this.checked = "2";
    }

    console.log(this.wx);
    if (this.wx && this.$route.query?.code) {
      this.getOpenId();
    }
  },
  computed: {
    canWeChat() {
      return this.channel == 1 || this.channel == 3;
    },
    canAlipay() {
      return this.channel == 2 || this.channel == 3;
    },
  },
  methods: {
    onSubmit() {
      if (!this.canWeChat && !this.canAlipay) {
        this.getPaymentChannel();
        return;
      }
      console.info("checked: " + this.checked);
      if (this.checked === "1") {
        if (this.wx) {
          if (this.openId) {
            this.wx_jsapi();
          } else {
            this.getAppInfo();
          }
        } else {
          this.wx_h5();
        }
      } else {
        this.alipay();
      }
    },
    alipay() {
      let param = {
        orderNo: this.orderNo
      };
      client.post("/api/h5/pay/alipay/prepay", param)
          .then(res => {
            this.alipayForm = res.data;
            console.log(res)
            // window.location.href = res.data;
          })
          .then(() => {
            this.$nextTick(() => {
              this.$refs.alipayFormWrapper.children[0].submit();
            })
          })
    },
    wx_h5() {
      let param = {
        orderNo: this.orderNo
      };
      client.post("/api/h5/pay/wechat/prepay", param)
          .then(res => {
            window.location.href = res.data;
          })
    },
    wx_jsapi() {
      let param = {
        orderNo: this.orderNo,
        openId: this.openId
      };
      client.post("/api/h5/pay/wechat/jsapi/prepay", param)
          .then(res => {
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                  "appId": res.data.appId,   //公众号ID，由商户传入
                  "timeStamp": res.data.timeStamp,   //时间戳，自1970年以来的秒数
                  "nonceStr": res.data.nonceStr,      //随机串
                  "package": res.data.packageStr,
                  "signType": "RSA",     //微信签名方式：
                  "paySign": res.data.paySign
                },
                (res) => {
                  console.log(res)
                  if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  }
                  this.payConfirm();
                });
          })
    },
    getOpenId() {
      client.post("/api/h5/pay/wechat/jsapi/openid/" + this.$route.query?.code, {orderNo: this.orderNo}).then(res => {
        console.log(res)
        this.openId = res.data;
        this.wx_jsapi();
      })
    },
    getWxCode(appid) {
      const uri = this.getRedirectUrl()
      console.log(uri);
      const redirectUri = this.urlEncode(uri)
      console.log(redirectUri);
      const scope = 'snsapi_base' // SCOPE
      // const agentid = process.env.VUE_APP_WECOM_AGENTID // AGENTID
      // const state = 'mnjd93nso2q0=' // STATE

      // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx62cd6f1468c0fb47&redirect_uri=https://www.virgindatax.com/scanVerify/chargePay&response_type=code&scope=snsapi_base&state=122#wechat_redirect
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
          + 'appid=' + appid
          + '&redirect_uri=' + redirectUri
          + '&response_type=code'
          + '&scope=' + scope
          // + '&agentid=' + agentid
          + '&state=' + Math.floor(Math.random() * 100000000000) + '#wechat_redirect'
      // appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE#wechat_redirect
      // window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx62cd6f1468c0fb47&redirect_uri=http://www.ai2049.com&response_type=code&scope=snsapi_login&state=12saqw#wechat_redirect'
    },
    getRedirectUrl() {
      let path = process.env.VUE_APP_ROUTER_BASE_URL;
      if(this.paymentType === '零星收费'){
        return window.location.protocol + "//" + window.location.host + (path ? path : "/") + 'scanVerify/chargeSporadicPay?orderNo=' + this.orderNo + '&orderAmount=' + this.orderAmount + '&channel=' + this.channel;
      }
      return window.location.protocol + "//" + window.location.host + (path ? path : "/") + 'scanVerify/chargePay?orderNo=' + this.orderNo + '&orderAmount=' + this.orderAmount + '&channel=' + this.channel;
    },
    urlEncode(str) {
      str = (str + '').toString();
      return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    getAppInfo() {
      client.post("/api/h5/pay/wechat/jsapi/appinfo", {orderNo: this.orderNo}).then(res => {
        console.log(res);
        this.paymentType = res.data.paymentType;
        this.getWxCode(res.data.appid);
      })
    },
    payConfirm() {
      if(this.$route.path === '/scanVerify/chargePay'){
        this.$router.replace({
          path: '/scanVerify/confirmPay', query: {
            orderNo: this.orderNo,
            orderAmount: this.orderAmount,
            payType: 'JSAPI'
          }
        });
      }else if(this.$route.path === '/scanVerify/chargeSporadicPay'){
        this.$router.replace({
          path: '/scanVerify/confirmSporadicPay', query: {
            orderNo: this.orderNo,
            orderAmount: this.orderAmount,
            payType: 'JSAPI'
          }
        });
      }
    },
    getPaymentChannel() {
      return client.get("/api/h5/pay/order/channel?orderNo=" + this.orderNo).then(res => {
        console.log(res);
        this.channel = res.data;
        if (this.wx) {
          if (this.channel === 2) {
            this.channel = 0;
          } else if (this.channel === 3) {
            this.channel = 1;
          }
        } else if (this.isAlipay) {
          if (this.channel === 1) {
            this.channel = 0;
          } else if (this.channel === 3) {
            this.channel = 2;
          }
        }
        if (this.channel === 0) {
          this.hint = "未配置收款方式，请联系相关营运人员";
        } else if (this.channel === 2) {
          this.checked = "2";
        }
      }).catch(error => {
        console.log(error);
        this.hint = error.response.data?.message;
      })
    },
  },
}
</script>

<style scoped>
.vg-content {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: stretch;
}

.header {
  align-self: center;
  display: flex;
  align-items: flex-end;
}

.item {
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.text {
  color: #101010;
  font-size: 16px;
}

.price {
  margin-top: 5px;
  margin-bottom: -3px;
  color: #101010;
  font-size: 26px;
}

.grow {
  flex-grow: 1;
}

.hint {
  margin: 35px 30px 0;
  color: #101010;
  font-size: 14px;
  align-self: center;
}

.image {
  margin-top: 120px;
  align-self: center;
}

.error {
  margin-top: 10px;
  color: #000000;
  font-size: 18px;
  align-self: center;
}
</style>
